import React from 'react';
import './BestellschluesselSchalldaempfer.css';


class BestellschluesselSchalldaempfer extends React.Component {
  kulissenspalt;
  constructor(props) {
    super(props);
    this.state = {
      value: null,
    };
  }

  render() {
    //   let test;
    // // eslint-disable-next-line no-unused-expressions
    //
    //   console.log("test Kulissensoaltbreite: " + test)
      return (
        <>{this.props.Kulissentyp}{this.props.Kulissenbreite}-{this.props.Kulissenspaltbreite.toFixed(0)}-{this.props.Kulissenanzahl}-
            {this.props.SelectedAnschlussprofil}-{this.props.Schalldaempferbreite}-{this.props.Schalldaempferhoehe}-{this.props.Schalldaempferlaenge}
        </>


    );
  }
}
export default BestellschluesselSchalldaempfer;
